import useSession from 'components/auth/useSession'
import { isCboPermission, isPermission } from 'components/auth/useSessionUtils'
import { AcessoCbo } from 'graphql/types.generated'
import React from 'react'
import { Redirect, Route, RouteProps } from 'react-router'
import { Permission } from 'types/Permissions'

export interface PrivateRouteProps extends RouteProps {
  permission: Permission | AcessoCbo[]
}

export const PrivateRoute = (props: PrivateRouteProps) => {
  const { permission, ...rest } = props

  const { hasAuthorization, hasCboAuth } = useSession({ fetchPolicy: 'cache-only' })

  if (
    (isPermission(props.permission) && hasAuthorization(props.permission)) ||
    (isCboPermission(props.permission) && hasCboAuth(props.permission))
  ) {
    return <Route {...rest} />
  }

  return <Redirect to='/403' />
}
